/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */

import axios from "axios";
import { emailPhone } from "containers/utils";

import { bucketEnumMapping } from "store/bucketEnumMapping";
import { Decrypt } from "containers/Login/AESHandler";
import * as actionTypes from "../actionTypes";

import { getAuthToken } from "../../authConfig";
import {
  ONGOING_PROCESS,
  QC_ALLOCATED_PROCESS,
  DEFAULT_PAGE_SIZE,
} from "../../../Data/constants";
import { addToast } from "../../../components/Toast/actions";

const SIZE = 5;
const JUBILANT_CLIENT = "Client Access";
const JUBILANT_CLIENT_PROCESS_KEY = "jubilant_food_process";
const MARICO_RETAIL_AUDIT_PROCESS_KEY = "marico_retail_audit_process";
const TCPL_PRODUCT_DEFECT_AUDIT_PROCESS_KEY = "tcpl_product_defect_audit_process";

const role = () => {
  return localStorage.getItem("userRole");
};

function formatCustomDate(date) {
  const [year, month, day] = date.split("-");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return `${day} ${months[parseInt(month, 10) - 1]} ${year}`;
}

function getDatesBetween(startDate, endDate) {
  const datesArray = [];
  const currentDate = new Date(startDate);

  while (currentDate <= new Date(endDate)) {
    const formattedDate = formatCustomDate(
      currentDate.toISOString().slice(0, 10)
    );
    datesArray.push(formattedDate);
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return datesArray;
}

export const convertToRawQuery = (filter_query, bucket) => {
  const outputArr = [];
  const outputDateArr = [];

  Object.keys(filter_query).forEach((key) => {
    if (
      typeof filter_query[key] === "string"
      && filter_query[key].includes("DATE-IDENTIFIER")
    ) {
      const [startDate, endDate] = filter_query[key].split("DATE-IDENTIFIER");
      const dateArr = getDatesBetween(startDate, endDate);
      if (
        key === "wf_submitted_on_new"
        || key === "wf_submiited_on_new"
        || key === "qc_submitted_on_new"
        || key === "qc_submiited_on_new"
        || key === "wf_assigned_on_string"
        || key === "task_uploaded_on"
        || key === "task_assigned_on"
      ) {
        // adding the wrong spelling because of adding of a variable with this name in some workflows
        outputArr.push({
          name: key,
          operation: "likeIgnoreCase",
          value: null,
          multipeValue: dateArr,
          type: "string",
          variableOperation: "LIKE_IGNORE_CASE",
        });
      } else {
        outputDateArr.push(
          {
            name: key,
            operation: "greaterThanOrEquals",
            value: startDate,
            type: "date",
            variableOperation: "GREATER_THAN",
          },
          {
            name: key,
            operation: "lessThanOrEquals",
            value: endDate,
            type: "date",
            variableOperation: "LESS_THAN",
          }
        );
      }
    } else {
      let queryArr = filter_query[key].split(",").map((item) => item.trim());
      if (queryArr.length > 1) {
        outputArr.push({
          name: key,
          operation: "likeIgnoreCase",
          value: null,
          multipeValue: queryArr,
          type: typeof filter_query[key],
          variableOperation: "LIKE_IGNORE_CASE",
        });
      } else {
        outputDateArr.push({
          name: key,
          operation: "likeIgnoreCase",
          value: `%${filter_query[key]}%`,
          type: typeof filter_query[key],
          variableOperation: "LIKE_IGNORE_CASE",
        });
      }
    }
  });

  if (bucket) {
    outputDateArr.push({
      name: "entityStage",
      operation: "likeIgnoreCase",
      value: `%${bucketEnumMapping[bucket]}%`,
      type: "string",
      variableOperation: "LIKE_IGNORE_CASE",
    });
  }

  if (role() === "qc-admin") {
    outputDateArr.push({
      name: "qc_assigned_to",
      operation: "likeIgnoreCase",
      value: `%${Decrypt(localStorage.getItem("userEmail"))}%`,
      type: "string",
      variableOperation: "LIKE_IGNORE_CASE",
    });
  }

  // eslint-disable-next-line no-console
  console.log("role==>", role());

  if (role() === "OG Vendor") {
    outputDateArr.push({
      name: "wf_assigned_to",
      operation: "likeIgnoreCase",
      value: `%${Decrypt(localStorage.getItem("userEmail"))}%`,
      type: "string",
      variableOperation: "LIKE_IGNORE_CASE",
    });
  }

  return { raw_query: outputDateArr, multi_select_query: outputArr };
};

export const processStart = () => {
  return {
    type: actionTypes.PROCESS_START,
  };
};

export const processSuccess = (
  process,
  currentProcess,
  ongoing = null,
  openBucket = null,
  reworkBucket = null,
  assignedBucket = null,
  submittedBucket = null,
  qcAllocatedBucket = null,
  qcDoneBucket = null,
  qcRejectedBucket = null,
  completed = null,
  withdrawn = null,
  process_key = "",
  process_type = ONGOING_PROCESS,
  name,
  page,
  pageSize = DEFAULT_PAGE_SIZE,
  selectedAppFormFields,
  filterOptions,
  selectedOption,
  processStateFilter
) => {
  let allAppsAdvFilterQuery = {};
  process.data.data.map((workflow) => {
    let processKey = workflow.process_key;
    allAppsAdvFilterQuery[processKey] = process.data.filter_query[processKey] || {};
    return null;
  });
  return {
    type: actionTypes.PROCESS_SUCCESS,
    apps:
      role() === JUBILANT_CLIENT
        ? process.data.data.filter(
            (item) => item.process_key === JUBILANT_CLIENT_PROCESS_KEY
          )
        : process.data.data,
    name: name,
    app: currentProcess,
    process_type: process_type,
    withdrawn: withdrawn ? withdrawn.data.data.data : [],
    withdrawnCount: withdrawn ? withdrawn.data.data.total : 0,
    ongoing: ongoing ? ongoing.data.data.data : [],
    ongoingCount: ongoing ? ongoing.data.data.total : 0,
    openBucket: openBucket ? openBucket.data.data.data : [],
    openBucketCount: openBucket ? openBucket.data.data.total : 0,
    reworkBucket: reworkBucket ? reworkBucket.data.data.data : [],
    reworkBucketCount: reworkBucket ? reworkBucket.data.data.total : 0,
    assignedBucket: assignedBucket ? assignedBucket.data.data.data : [],
    assignedBucketCount: assignedBucket ? assignedBucket.data.data.total : 0,
    submittedBucket: submittedBucket ? submittedBucket.data.data.data : [],
    submittedBucketCount: submittedBucket ? submittedBucket.data.data.total : 0,
    qcAllocatedBucket: qcAllocatedBucket
      ? qcAllocatedBucket.data.data.data
      : [],
    qcAllocatedBucketCount: qcAllocatedBucket
      ? qcAllocatedBucket.data.data.total
      : 0,
    qcDoneBucket: qcDoneBucket ? qcDoneBucket.data.data.data : [],
    qcDoneBucketCount: qcDoneBucket ? qcDoneBucket.data.data.total : 0,
    qcRejectedBucket: qcRejectedBucket ? qcRejectedBucket.data.data.data : [],
    qcRejectedBucketCount: qcRejectedBucket
      ? qcRejectedBucket.data.data.total
      : 0,
    completed: completed ? completed.data.data.data : [],
    completedCount: completed ? completed.data.data.total : 0,
    process_key: process_key,
    selectedFormFields: selectedAppFormFields,
    selected_card_list: [],
    offset: page,
    size: pageSize,
    filterOptions,
    selectedOption,
    processStateFilter,
    allAppsAdvFilterQuery,
  };
};

export const updateAdvancedFilter = (
  processKey,
  filterQuery,
  filterType,
  ongoing = null,
  openBucket = null,
  reworkBucket = null,
  assignedBucket = null,
  submittedBucket = null,
  qcAllocatedBucket = null,
  qcDoneBucket = null,
  qcRejectedBucket = null,
  completed = null,
  withdrawn = null
) => {
  return {
    type: actionTypes.UPDATE_ADVANCED_FILTER,
    ongoing: ongoing ? ongoing.data.data.data : [],
    openBucket: openBucket ? openBucket.data.data.data : [],
    openBucketCount: openBucket ? openBucket.data.data.total : 0,
    reworkBucket: reworkBucket ? reworkBucket.data.data.data : [],
    reworkBucketCount: reworkBucket ? reworkBucket.data.data.total : 0,
    assignedBucket: assignedBucket ? assignedBucket.data.data.data : [],
    assignedBucketCount: assignedBucket ? assignedBucket.data.data.total : 0,
    submittedBucket: submittedBucket ? submittedBucket.data.data.data : [],
    submittedBucketCount: submittedBucket ? submittedBucket.data.data.total : 0,
    qcAllocatedBucket: qcAllocatedBucket
      ? qcAllocatedBucket.data.data.data
      : [],
    qcAllocatedBucketCount: qcAllocatedBucket
      ? qcAllocatedBucket.data.data.total
      : 0,
    qcDoneBucket: qcDoneBucket ? qcDoneBucket.data.data.data : [],
    qcDoneBucketCount: qcDoneBucket ? qcDoneBucket.data.data.total : 0,
    qcRejectedBucket: qcRejectedBucket ? qcRejectedBucket.data.data.data : [],
    qcRejectedBucketCount: qcRejectedBucket
      ? qcRejectedBucket.data.data.total
      : 0,
    completed: completed ? completed.data.data.data : [],
    withdrawn: withdrawn ? withdrawn.data.data.data : [],
    ongoingCount: ongoing ? ongoing.data.data.total : 0,
    completedCount: completed ? completed.data.data.total : 0,
    withdrawnCount: withdrawn ? withdrawn.data.data.total : 0,
    processKey,
    filterQuery,
    filterType,
  };
};

export const updateAdvancedFilterTask = (
  processKey,
  filterQuery,
  filterType,
  ongoing = null,
  openBucket = null,
  reworkBucket = null,
  assignedBucket = null,
  submittedBucket = null,
  qcAllocatedBucket = null,
  qcDoneBucket = null,
  qcRejectedBucket = null,
  completed = null,
  withdrawn = null
) => {
  return {
    type: actionTypes.UPDATE_ADVANCED_FILTER_TASK,
    ongoing: ongoing ? ongoing.data.data.data : [],
    openBucket: openBucket ? openBucket.data.data.data : [],
    openBucketCount: openBucket ? openBucket.data.data.total : 0,
    reworkBucket: reworkBucket ? reworkBucket.data.data.data : [],
    reworkBucketCount: reworkBucket ? reworkBucket.data.data.total : 0,
    assignedBucket: assignedBucket ? assignedBucket.data.data.data : [],
    assignedBucketCount: assignedBucket ? assignedBucket.data.data.total : 0,
    submittedBucket: submittedBucket ? submittedBucket.data.data.data : [],
    submittedBucketCount: submittedBucket ? submittedBucket.data.data.total : 0,
    qcAllocatedBucket: qcAllocatedBucket
      ? qcAllocatedBucket.data.data.data
      : [],
    qcAllocatedBucketCount: qcAllocatedBucket
      ? qcAllocatedBucket.data.data.total
      : 0,
    qcDoneBucket: qcDoneBucket ? qcDoneBucket.data.data.data : [],
    qcDoneBucketCount: qcDoneBucket ? qcDoneBucket.data.data.total : 0,
    qcRejectedBucket: qcRejectedBucket ? qcRejectedBucket.data.data.data : [],
    qcRejectedBucketCount: qcRejectedBucket
      ? qcRejectedBucket.data.data.total
      : 0,
    completed: completed ? completed.data.data.data : [],
    withdrawn: withdrawn ? withdrawn.data.data.data : [],
    ongoingCount: ongoing ? ongoing.data.data.total : 0,
    completedCount: completed ? completed.data.data.total : 0,
    withdrawnCount: withdrawn ? withdrawn.data.data.total : 0,
    processKey,
    filterQuery,
    filterType,
  };
};

export const processDetailsOngoing = (ongoing, offset) => {
  return {
    type: actionTypes.PROCESS_DETAILS_PAGINATION,
    ongoing: ongoing.data.data.data,
    total: ongoing.data.data.total,
    offset: offset,
  };
};

export const processDetailsOpenBucket = (openBucket, offset) => {
  return {
    type: actionTypes.PROCESS_OPEN_BUCKET,
    openBucket: openBucket.data.data.data,
    total: openBucket.data.data.total,
    offset: offset,
  };
};

export const processDetailsReworkBucket = (reworkBucket, offset) => {
  return {
    type: actionTypes.PROCESS_REWORK_BUCKET,
    reworkBucket: reworkBucket.data.data.data,
    total: reworkBucket.data.data.total,
    offset: offset,
  };
};
export const processDetailsAssignedBucket = (assignedBucket, offset) => {
  return {
    type: actionTypes.PROCESS_ASSIGNED_BUCKET,
    assignedBucket: assignedBucket.data.data.data,
    total: assignedBucket.data.data.total,
    offset: offset,
  };
};
export const processDetailsSubmittedBucket = (submittedBucket, offset) => {
  return {
    type: actionTypes.PROCESS_SUBMITTED_BUCKET,
    submittedBucket: submittedBucket.data.data.data,
    total: submittedBucket.data.data.total,
    offset: offset,
  };
};

export const processDetailsQcAllocatedBucket = (qcAllocatedBucket, offset) => {
  return {
    type: actionTypes.PROCESS_QC_ALLOCATED_BUCKET,
    qcAllocatedBucket: qcAllocatedBucket.data.data.data,
    total: qcAllocatedBucket.data.data.total,
    offset: offset,
  };
};

export const processDetailsQcDoneBucket = (qcDoneBucket, offset) => {
  return {
    type: actionTypes.PROCESS_QC_DONE_BUCKET,
    qcDoneBucket: qcDoneBucket.data.data.data,
    total: qcDoneBucket.data.data.total,
    offset: offset,
  };
};
export const processDetailsQcRejectedBucket = (qcRejectedBucket, offset) => {
  return {
    type: actionTypes.PROCESS_QC_REJECTED_BUCKET,
    qcRejectedBucket: qcRejectedBucket.data.data.data,
    total: qcRejectedBucket.data.data.total,
    offset: offset,
  };
};

export const processWithdraw = (id) => {
  return {
    type: actionTypes.PROCESS_WITHDRAW,
    id,
  };
};

export const processDetailsCompleted = (completed, offset) => {
  return {
    type: actionTypes.PROCESS_DETAILS_COMPLETED,
    completed: completed.data.data.data,
    total: completed.data.data.total,
    offset: offset,
  };
};

const getSelectedFields = (id) => {
  return axios.get(`/api/apps/process_view/${id}/process_view_data`);
};

export const clearAllSelected = () => {
  return {
    type: actionTypes.CLEAR_ALL,
    clearAll: [],
  };
};

export const selectedProcessType = (processType) => {
  return {
    type: actionTypes.SELECT_DETAILS,
    processType,
  };
};
export const setDateValueAdvFilter = (dateValueObj) => {
  return {
    type: actionTypes.SET_DATE_VALUE,
    dateValueObj,
  };
};

export const setProcessSize = (size) => {
  return {
    type: actionTypes.SET_PROCESS_SIZE,
    size,
  };
};

export const selectedprocessCard = (event, id, email, phone, switchAll) => {
  return {
    type: actionTypes.SELECT_CARD_DETAILS,
    event: event,
    id: id,
    email: email,
    phone: phone,
    selected_all: switchAll,
  };
};

export const selectedCardsList = (selected_all) => {
  return {
    type: actionTypes.SELECT_CARD_ALL,
    selected_all: selected_all,
  };
};

export const processDetails = (
  app,
  name = null,
  ongoing = null,
  openBucket = null,
  reworkBucket = null,
  assignedBucket = null,
  submittedBucket = null,
  qcAllocatedBucket = null,
  qcDoneBucket = null,
  qcRejectedBucket = null,
  completed = null,
  withdrawn = null,
  selectedFormFieldsdata = null,
  process_key = "",
  filteredOptions,
  selectedOption,
  processStateFilter
) => {
  return {
    type: actionTypes.PROCESS_DETAILS,
    name: name,
    withdrawn: withdrawn ? withdrawn.data.data.data : [],
    withdrawnCount: withdrawn ? withdrawn.data.data.total : 0,
    ongoing: ongoing ? ongoing.data.data.data : [],
    openBucket: openBucket ? openBucket.data.data.data : [],
    openBucketCount: openBucket ? openBucket.data.data.total : 0,
    reworkBucket: reworkBucket ? reworkBucket.data.data.data : [],
    reworkBucketCount: reworkBucket ? reworkBucket.data.data.total : 0,
    assignedBucket: assignedBucket ? assignedBucket.data.data.data : [],
    assignedBucketCount: assignedBucket ? assignedBucket.data.data.total : 0,
    submittedBucket: submittedBucket ? submittedBucket.data.data.data : [],
    submittedBucketCount: submittedBucket ? submittedBucket.data.data.total : 0,
    qcAllocatedBucket: qcAllocatedBucket
      ? qcAllocatedBucket.data.data.data
      : [],
    qcAllocatedBucketCount: qcAllocatedBucket
      ? qcAllocatedBucket.data.data.total
      : 0,
    qcDoneBucket: qcDoneBucket ? qcDoneBucket.data.data.data : [],
    qcDoneBucketCount: qcDoneBucket ? qcDoneBucket.data.data.total : 0,
    qcRejectedBucket: qcRejectedBucket ? qcRejectedBucket.data.data.data : [],
    qcRejectedBucketCount: qcRejectedBucket
      ? qcRejectedBucket.data.data.total
      : 0,
    ongoingCount: ongoing ? ongoing.data.data.total : 0,
    completed: completed ? completed.data.data.data : [],
    completedCount: completed ? completed.data.data.total : 0,
    selectedFormFields: selectedFormFieldsdata,
    process_key: process_key,
    app: app.data.data,
    filteredOptions,
    selectedOption,
    processStateFilter,
  };
};

export const startProcessForm = (formData, submission_data) => {
  return {
    type: actionTypes.START_PROCESS_FORM,
    formData: formData,
    submission_data,
  };
};

export const startFormError = () => {
  return {
    type: actionTypes.START_PROCESS_ERROR,
  };
};
export const processLaunch = (data) => {
  return {
    type: actionTypes.PROCESS_LAUNCH,
    data: data,
  };
};

export const processFail = (error) => {
  return {
    type: actionTypes.PROCESS_ERROR,
    error: error,
  };
};

export const processLaunchFail = () => {
  return {
    type: actionTypes.PROCESS_LAUNCH_ERROR,
  };
};

const processDetailsWithdrawn = (withdrawn, offset) => {
  return {
    type: actionTypes.WITHDRAWN_PROCESS_PAGINATION,
    withdrawn: withdrawn.data.data.data,
    total: withdrawn.data.data.total,
    offset,
  };
};

const taskUsers = (data) => {
  return {
    type: actionTypes.GET_TASK_USERS,
    data,
  };
};

export const processSearchResult = (results, processType, searchData, page) => {
  return {
    type: actionTypes.PROCESS_SEARCH,
    results: results.data.data,
    searchData,
    processType,
    offset: page,
  };
};

export const processSearchResultCount = (processType, count, data) => {
  return {
    type: actionTypes.PROCESS_SEARCH_COUNT,
    count: count,
    process_type: processType,
    data: data,
  };
};

export const clearProcessSearchResult = () => {
  return {
    type: actionTypes.CLEAR_SEARCH,
  };
};

export const getAllProcess = (
  processKey,
  type,
  page,
  pageSize,
  filters,
  selectedFilter
) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(processStart());
      getAuthToken();
      return axios
        .get(
          "/api/apps/?is_global=true"
          // eslint-disable-next-line consistent-return
        )
        .then((process) => {
          // eslint-disable-next-line no-console
          console.log("process", process);
          let process_key;
          let viewPermission;
          let process_type;
          let name;
          let id;
          let currentProcess = [];
          let start = 0;
          let advFilterQuery = {};

          // eslint-disable-next-line no-console
          console.log("page==>", page);
          if (page > 1) {
            start = (page - 1) * MARICO_RETAIL_AUDIT_PROCESS_KEY ? 5 : pageSize;
          }
          // eslint-disable-next-line no-console
          console.log("start==>", start);

          let selectedApp = "";
          let processStateFilter = null;
          if (role() === JUBILANT_CLIENT) {
            selectedApp = JUBILANT_CLIENT_PROCESS_KEY;
          } else if (processKey) {
            selectedApp = processKey;
          } else {
            selectedApp = process.data.filterData.processDefinitionKey;
          }
          if (process.data.filterData.processStateFilter) {
            processStateFilter = process.data.filterData.processStateFilter;
          }

          let click_process = process.data.data.filter(
            (app) => app.process_key === selectedApp
          );

          if (click_process.length) {
            process_key = click_process[0].process_key;
            viewPermission = click_process[0].view_permission;
            currentProcess = click_process[0];
            name = click_process[0].name;
            id = click_process[0].id;
            advFilterQuery = process.data.filter_query
              ? process.data.filter_query[process_key] || {}
              : {};
          } else {
            const firstData = role() === JUBILANT_CLIENT
                ? process.data.data?.filter(
                    (item) => item.process_key === JUBILANT_CLIENT_PROCESS_KEY
                  )[0]
                : process.data.data;

            process_key = firstData[0].process_key;
            viewPermission = firstData[0].view_permission;
            name = firstData[0].name;
            currentProcess = firstData[0];
            id = firstData[0].id;
            advFilterQuery = process.data.filter_query
              ? process.data.filter_query[process_key] || {}
              : {};
          }

          if (role() === JUBILANT_CLIENT) process_type = QC_ALLOCATED_PROCESS;
          else if (type) process_type = type;
          else process_type = ONGOING_PROCESS;

          let size = process_key === MARICO_RETAIL_AUDIT_PROCESS_KEY
            || process_key === TCPL_PRODUCT_DEFECT_AUDIT_PROCESS_KEY
              ? 5
              : pageSize;

          let activeFilter = "";
          let filterOptions = [];
          let selectedOption = "";
          if (filters && process_key in filters) {
            let processFilter = filters[process_key];
            if (Array.isArray(processFilter) && processFilter.length > 1) {
              if (selectedFilter) {
                activeFilter = `?filter=${selectedFilter}`;
                selectedOption = selectedFilter;
                filterOptions = processFilter;
              } else {
                activeFilter = `?filter=${processFilter[0]}`;
                selectedOption = processFilter[0];
                filterOptions = processFilter;
              }
            }
          }
          function completed() {
            let payload = {
              processDefinitionKey: process_key,
              start: start,
              size: size,
              sort: "endTime",
              order: "desc",
              finished: true,
              deleted: false,
              includeProcessVariables: true,
              ...convertToRawQuery(advFilterQuery, "completed"),
              query_data: { ...advFilterQuery },
            };
            return axios.post(
              `/api/apps/process-instances${activeFilter}`,
              payload
            );
          }
          function ongoing() {
            let payload = {
              processDefinitionKey: process_key,
              start: start,
              size: size,
              sort: "startTime",
              order: "desc",
              finished: false,
              deleted: false,
              includeProcessVariables: true,
              selectedState: processStateFilter,
              ...convertToRawQuery(advFilterQuery),
              query_data: { ...advFilterQuery },
            };
            return axios.post(
              `/api/apps/process-instances${activeFilter}`,
              payload
            );
          }
          function openBucket() {
            let payload = {
              processDefinitionKey: process_key,
              start: start,
              size: size,
              sort: "startTime",
              order: "desc",
              finished: false,
              deleted: false,
              includeProcessVariables: true,
              selectedState: processStateFilter,
              ...convertToRawQuery(advFilterQuery, "open"),
              query_data: { ...advFilterQuery },
            };
            return axios.post(
              `/api/apps/process-instances${activeFilter}`,
              payload
            );
          }
          function reworkBucket() {
            let payload = {
              processDefinitionKey: process_key,
              start: start,
              size: size,
              sort: "startTime",
              order: "desc",
              finished: false,
              deleted: false,
              includeProcessVariables: true,
              selectedState: processStateFilter,
              ...convertToRawQuery(advFilterQuery, "rework"),
              query_data: { ...advFilterQuery },
            };
            return axios.post(
              `/api/apps/process-instances${activeFilter}`,
              payload
            );
          }
          function assignedBucket() {
            let payload = {
              processDefinitionKey: process_key,
              start: start,
              size: size,
              sort: "startTime",
              order: "desc",
              finished: false,
              deleted: false,
              includeProcessVariables: true,
              selectedState: processStateFilter,
              ...convertToRawQuery(advFilterQuery, "assigned"),
              query_data: { ...advFilterQuery },
            };
            return axios.post(
              `/api/apps/process-instances${activeFilter}`,
              payload
            );
          }
          function submittedBucket() {
            let payload = {
              processDefinitionKey: process_key,
              start: start,
              size: size,
              sort: "startTime",
              order: "desc",
              finished: false,
              deleted: false,
              includeProcessVariables: true,
              selectedState: processStateFilter,
              ...convertToRawQuery(advFilterQuery, "submitted"),
              query_data: { ...advFilterQuery },
            };
            return axios.post(
              `/api/apps/process-instances${activeFilter}`,
              payload
            );
          }
          function qcAllocatedBucket() {
            let payload = {
              processDefinitionKey: process_key,
              start: start,
              size: size,
              sort: "startTime",
              order: "desc",
              finished: false,
              deleted: false,
              includeProcessVariables: true,
              selectedState: processStateFilter,
              ...convertToRawQuery(advFilterQuery, "qcAllocated"),
              query_data: { ...advFilterQuery },
            };
            return axios.post(
              `/api/apps/process-instances${activeFilter}`,
              payload
            );
          }
          function qcDoneBucket() {
            let payload = {
              processDefinitionKey: process_key,
              start: start,
              size: size,
              sort: "startTime",
              order: "desc",
              finished: false,
              deleted: false,
              includeProcessVariables: true,
              selectedState: processStateFilter,
              ...convertToRawQuery(advFilterQuery, "qcDone"),
              query_data: { ...advFilterQuery },
            };
            return axios.post(
              `/api/apps/process-instances${activeFilter}`,
              payload
            );
          }
          function qcRejectedBucket() {
            let payload = {
              processDefinitionKey: process_key,
              start: start,
              size: size,
              sort: "startTime",
              order: "desc",
              finished: true,
              deleted: false,
              includeProcessVariables: true,
              selectedState: processStateFilter,
              ...convertToRawQuery(advFilterQuery, "qcRejected"),
              query_data: { ...advFilterQuery },
            };
            return axios.post(
              `/api/apps/process-instances${activeFilter}`,
              payload
            );
          }
          function withdrawn() {
            let payload = {
              processDefinitionKey: process_key,
              start: start,
              size: size,
              sort: "endTime",
              order: "desc",
              finished: true,
              deleted: true,
              includeProcessVariables: true,
              ...convertToRawQuery(advFilterQuery),
              query_data: { ...advFilterQuery },
            };
            return axios.post(
              `/api/apps/process-instances${activeFilter}`,
              payload
            );
          }
          if (viewPermission) {
            axios
              .all([
                ongoing(),
                openBucket(),
                reworkBucket(),
                assignedBucket(),
                submittedBucket(),
                qcAllocatedBucket(),
                qcDoneBucket(),
                qcRejectedBucket(),
                completed(),
                withdrawn(),
                getSelectedFields(id),
              ])
              .then((res) => {
                let selectedAppFormFields = res[3].data.data.id
                  ? res[3].data.data.selected_form_fields
                  : [];
                dispatch(
                  processSuccess(
                    process,
                    currentProcess,
                    res[0],
                    res[1],
                    res[2],
                    res[3],
                    res[4],
                    res[5],
                    res[6],
                    res[7],
                    res[8],
                    res[9],
                    process_key,
                    process_type,
                    name,
                    page,
                    size,
                    selectedAppFormFields,
                    filterOptions,
                    selectedOption,
                    processStateFilter
                  )
                );
                return resolve();
              })
              .catch((err) => {
                dispatch(
                  processSuccess(
                    process,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    process_key,
                    process_type,
                    name,
                    [],
                    null
                  )
                );
                if (err.response && err.response.status) {
                  if (err.response.status !== 500) {
                    dispatch(
                      addToast("error", "Error", err.response.data.message)
                    );
                  } else {
                    dispatch(
                      addToast("error", "Error", "Something Went Wrong!")
                    );
                  }
                }
                return resolve();
              });
          } else {
            dispatch(processSuccess(process));
            return resolve();
          }
          return null;
        })
        .catch((err) => {
          dispatch(processFail(err.response));
          if (err.response && err.response.status) {
            if (err.response.status !== 500) {
              dispatch(addToast("error", "Error", err.response.data.message));
            } else {
              dispatch(addToast("error", "Error", "Something Went Wrong!"));
            }
          }
          return reject();
        });
    });
  };
};

export const withdrawProcess = (
  id,
  comment,
  page,
  processKey,
  pageSize,
  history
) => {
  return (dispatch, getState) => {
    const pageNum = Number(page);
    const processType = getState().process.processType;
    const ongoingDataCount = getState().process.ongoingCount;
    dispatch(processStart());
    getAuthToken();
    let url = `/api/proxy-bpm/process-instances/delete/${id}?deleteReason=${comment}`;
    axios
      .delete(url)
      .then((response) => {
        dispatch(processWithdraw(id));
        dispatch(addToast("success", "Success", response.data.message));

        const lastPage = Math.ceil(ongoingDataCount / 5);

        const pageNumber = ongoingDataCount % 5 === 1 && lastPage === pageNum
            ? pageNum - 1
            : pageNum;

        history.push({
          pathname: "/process",
          search: `?process_key=${processKey}&processType=${processType}&page=${pageNumber}&size=${pageSize}`,
        });
      })
      .catch((err) => {
        dispatch(addToast("error", "Error", err.response.data.message));
        dispatch(processFail(err.response));
      });
  };
};

export const getFilterProcess = (
  processType,
  name,
  id,
  process_key,
  selectedFormFields,
  pageSize,
  filters,
  selectedFilter,
  selectedState
) => {
  return (dispatch, getState) => {
    dispatch(processStart());
    getAuthToken();
    let activeFilter = "";
    let filterOptions = null;
    let selectedOption = "";
    let processStateFilter = null;
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    if (selectedState) {
      processStateFilter = selectedState;
    }
    if (filters && process_key in filters) {
      let processFilter = filters[process_key];
      if (Array.isArray(processFilter) && processFilter.length > 1) {
        if (selectedFilter) {
          activeFilter = `?filter=${selectedFilter}`;
          selectedOption = selectedFilter;
        } else {
          activeFilter = `?filter=${processFilter[0]}`;
          selectedOption = processFilter[0];
        }
        filterOptions = processFilter;
      }
    }

    axios
      .get(`/api/apps/${id}`)
      .then((app) => {
        let size = process_key === MARICO_RETAIL_AUDIT_PROCESS_KEY
          || process_key === TCPL_PRODUCT_DEFECT_AUDIT_PROCESS_KEY
            ? 5
            : DEFAULT_PAGE_SIZE;

        function completed() {
          let payload = {
            processDefinitionKey: process_key,
            start: 0,
            size: size,
            sort: "endTime",
            order: "desc",
            finished: true,
            deleted: false,
            includeProcessVariables: true,
            ...convertToRawQuery(advFilterQuery, "completed"),
            query_data: { ...advFilterQuery },
          };
          return axios.post(
            `/api/apps/process-instances${activeFilter}`,
            payload
          );
        }
        function ongoing() {
          let payload = {
            processDefinitionKey: process_key,
            start: 0,
            size: size,
            sort: "startTime",
            order: "desc",
            finished: false,
            deleted: false,
            includeProcessVariables: true,
            selectedState: processStateFilter,
            ...convertToRawQuery(advFilterQuery),
            query_data: { ...advFilterQuery },
          };

          return axios.post(
            `/api/apps/process-instances${activeFilter}`,
            payload
          );
        }
        function openBucket() {
          let payload = {
            processDefinitionKey: process_key,
            start: 0,
            size: size,
            sort: "startTime",
            order: "desc",
            finished: false,
            deleted: false,
            includeProcessVariables: true,
            selectedState: processStateFilter,
            ...convertToRawQuery(advFilterQuery, "open"),
            query_data: { ...advFilterQuery },
          };
          return axios.post(
            `/api/apps/process-instances${activeFilter}`,
            payload
          );
        }
        function reworkBucket() {
          let payload = {
            processDefinitionKey: process_key,
            start: 0,
            size: size,
            sort: "startTime",
            order: "desc",
            finished: false,
            deleted: false,
            includeProcessVariables: true,
            selectedState: processStateFilter,
            ...convertToRawQuery(advFilterQuery, "rework"),
            query_data: { ...advFilterQuery },
          };
          return axios.post(
            `/api/apps/process-instances${activeFilter}`,
            payload
          );
        }
        function assignedBucket() {
          let payload = {
            processDefinitionKey: process_key,
            start: 0,
            size: size,
            sort: "startTime",
            order: "desc",
            finished: false,
            deleted: false,
            includeProcessVariables: true,
            selectedState: processStateFilter,
            ...convertToRawQuery(advFilterQuery, "assigned"),
            query_data: { ...advFilterQuery },
          };
          return axios.post(
            `/api/apps/process-instances${activeFilter}`,
            payload
          );
        }
        function submittedBucket() {
          let payload = {
            processDefinitionKey: process_key,
            start: 0,
            size: size,
            sort: "startTime",
            order: "desc",
            finished: false,
            deleted: false,
            includeProcessVariables: true,
            selectedState: processStateFilter,
            ...convertToRawQuery(advFilterQuery, "submitted"),
            query_data: { ...advFilterQuery },
          };
          return axios.post(
            `/api/apps/process-instances${activeFilter}`,
            payload
          );
        }
        function qcAllocatedBucket() {
          let payload = {
            processDefinitionKey: process_key,
            start: 0,
            size: size,
            sort: "startTime",
            order: "desc",
            finished: false,
            deleted: false,
            includeProcessVariables: true,
            selectedState: processStateFilter,
            ...convertToRawQuery(advFilterQuery, "qcAllocated"),
            query_data: { ...advFilterQuery },
          };
          return axios.post(
            `/api/apps/process-instances${activeFilter}`,
            payload
          );
        }
        function qcDoneBucket() {
          let payload = {
            processDefinitionKey: process_key,
            start: 0,
            size: size,
            sort: "startTime",
            order: "desc",
            finished: false,
            deleted: false,
            includeProcessVariables: true,
            selectedState: processStateFilter,
            ...convertToRawQuery(advFilterQuery, "qcDone"),
            query_data: { ...advFilterQuery },
          };
          return axios.post(
            `/api/apps/process-instances${activeFilter}`,
            payload
          );
        }
        function qcRejectedBucket() {
          let payload = {
            processDefinitionKey: process_key,
            start: 0,
            size: size,
            sort: "startTime",
            order: "desc",
            finished: true,
            deleted: false,
            includeProcessVariables: true,
            selectedState: processStateFilter,
            ...convertToRawQuery(advFilterQuery, "qcRejected"),
            query_data: { ...advFilterQuery },
          };
          return axios.post(
            `/api/apps/process-instances${activeFilter}`,
            payload
          );
        }
        function withdrawn() {
          let payload = {
            processDefinitionKey: process_key,
            start: 0,
            size: size,
            sort: "endTime",
            order: "desc",
            finished: true,
            deleted: true,
            includeProcessVariables: true,
            ...convertToRawQuery(advFilterQuery),
            query_data: { ...advFilterQuery },
          };
          return axios.post(
            `/api/apps/process-instances${activeFilter}`,
            payload
          );
        }
        if (app.data.data.view_permission) {
          axios
            .all([
              ongoing(),
              openBucket(),
              reworkBucket(),
              assignedBucket(),
              submittedBucket(),
              qcAllocatedBucket(),
              qcDoneBucket(),
              qcRejectedBucket(),
              completed(),
              withdrawn(),
              getSelectedFields(id),
            ])
            .then((res) => {
              let selectedFormFieldsData = res[3].data.data.id
                ? res[3].data.data.selected_form_fields
                : [];
              dispatch(
                processDetails(
                  app,
                  name,
                  res[0],
                  res[1],
                  res[2],
                  res[3],
                  res[4],
                  res[5],
                  res[6],
                  res[7],
                  res[8],
                  res[9],
                  selectedFormFieldsData,
                  process_key,
                  filterOptions,
                  selectedOption,
                  processStateFilter
                )
              );
            })
            .catch((err) => {
              dispatch(
                processDetails(
                  app,
                  name,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  process_key,
                  [],
                  null
                )
              );
              if (err.response && err.response.status) {
                if (err.response.status !== 500) {
                  dispatch(
                    addToast("error", "Error", err.response.data.message)
                  );
                } else {
                  dispatch(addToast("error", "Error", "Something Went Wrong!"));
                }
              }
            });
        } else {
          dispatch(processDetails(app));
        }
      })
      .catch((err) => {
        dispatch(processFail(err.response));
        if (err.response && err.response.status) {
          if (err.response.status !== 500) {
            dispatch(addToast("error", "Error", err.response.data.message));
          } else {
            dispatch(addToast("error", "Error", "Something Went Wrong!"));
          }
        }
      });
  };
};

export const updateAdvancedFilteredData = (
  appData,
  filterQuery,
  filterType,
  pageSize
) => {
  return (dispatch) => {
    dispatch(processStart());
    getAuthToken();

    function ongoing() {
      let payload = {
        processDefinitionKey: appData.process_key,
        start: 0,
        size: pageSize || SIZE,
        sort: "startTime",
        order: "desc",
        finished: false,
        deleted: false,
        includeProcessVariables: true,
        ...convertToRawQuery(filterQuery),
        query_data: { ...filterQuery },
      };
      return axios.post("/api/apps/process-instances", payload);
    }
    function openBucket() {
      let payload = {
        processDefinitionKey: appData.process_key,
        start: 0,
        size: pageSize || SIZE,
        sort: "startTime",
        order: "desc",
        finished: false,
        deleted: false,
        includeProcessVariables: true,
        ...convertToRawQuery(filterQuery, "open"),
        query_data: { ...filterQuery },
      };
      return axios.post("/api/apps/process-instances", payload);
    }
    function reworkBucket() {
      let payload = {
        processDefinitionKey: appData.process_key,
        start: 0,
        size: pageSize || SIZE,
        sort: "startTime",
        order: "desc",
        finished: false,
        deleted: false,
        includeProcessVariables: true,
        ...convertToRawQuery(filterQuery, "rework"),
        query_data: { ...filterQuery },
      };
      return axios.post("/api/apps/process-instances", payload);
    }
    function assignedBucket() {
      let payload = {
        processDefinitionKey: appData.process_key,
        start: 0,
        size: pageSize || SIZE,
        sort: "startTime",
        order: "desc",
        finished: false,
        deleted: false,
        includeProcessVariables: true,
        ...convertToRawQuery(filterQuery, "assigned"),
        query_data: { ...filterQuery },
      };
      return axios.post("/api/apps/process-instances", payload);
    }
    function submittedBucket() {
      let payload = {
        processDefinitionKey: appData.process_key,
        start: 0,
        size: pageSize || SIZE,
        sort: "startTime",
        order: "desc",
        finished: false,
        deleted: false,
        includeProcessVariables: true,
        ...convertToRawQuery(filterQuery, "submitted"),
        query_data: { ...filterQuery },
      };
      return axios.post("/api/apps/process-instances", payload);
    }
    function qcAllocatedBucket() {
      let payload = {
        processDefinitionKey: appData.process_key,
        start: 0,
        size: pageSize || SIZE,
        sort: "startTime",
        order: "desc",
        finished: false,
        deleted: false,
        includeProcessVariables: true,
        ...convertToRawQuery(filterQuery, "qcAllocated"),
        query_data: { ...filterQuery },
      };
      return axios.post("/api/apps/process-instances", payload);
    }
    function qcDoneBucket() {
      let payload = {
        processDefinitionKey: appData.process_key,
        start: 0,
        size: pageSize || SIZE,
        sort: "startTime",
        order: "desc",
        finished: false,
        deleted: false,
        includeProcessVariables: true,
        ...convertToRawQuery(filterQuery, "qcDone"),
        query_data: { ...filterQuery },
      };
      return axios.post("/api/apps/process-instances", payload);
    }
    function qcRejectedBucket() {
      let payload = {
        processDefinitionKey: appData.process_key,
        start: 0,
        size: pageSize || SIZE,
        sort: "startTime",
        order: "desc",
        finished: true,
        deleted: false,
        includeProcessVariables: true,
        ...convertToRawQuery(filterQuery, "qcRejected"),
        query_data: { ...filterQuery },
      };
      return axios.post("/api/apps/process-instances", payload);
    }

    function completed() {
      let payload = {
        processDefinitionKey: appData.process_key,
        start: 0,
        size: pageSize || SIZE,
        sort: "endTime",
        order: "desc",
        finished: true,
        deleted: false,
        includeProcessVariables: true,
        ...convertToRawQuery(filterQuery, "completed"),
        query_data: { ...filterQuery },
      };
      return axios.post("/api/apps/process-instances", payload);
    }

    function withdrawn() {
      let payload = {
        processDefinitionKey: appData.process_key,
        start: 0,
        size: pageSize || SIZE,
        sort: "endTime",
        order: "desc",
        finished: true,
        deleted: true,
        includeProcessVariables: true,
        ...convertToRawQuery(filterQuery),
        query_data: { ...filterQuery },
      };
      return axios.post("/api/apps/process-instances", payload);
    }

    if (appData.view_permission) {
      axios
        .all([
          ongoing(),
          openBucket(),
          reworkBucket(),
          assignedBucket(),
          submittedBucket(),
          qcAllocatedBucket(),
          qcDoneBucket(),
          qcRejectedBucket(),
          completed(),
          withdrawn(),
        ])
        .then((res) => {
          dispatch(
            updateAdvancedFilter(
              appData.process_key,
              filterQuery,
              filterType,
              res[0],
              res[1],
              res[2],
              res[3],
              res[4],
              res[5],
              res[6],
              res[7],
              res[8],
              res[9]
            )
          );
        })
        .catch((err) => {
          dispatch(
            updateAdvancedFilter(appData.process_key, filterQuery, filterType)
          );
          if (err.response && err.response.status) {
            if (err.response.status !== 500) {
              dispatch(addToast("error", "Error", err.response.data.message));
            } else {
              dispatch(addToast("error", "Error", "Something Went Wrong!"));
            }
          }
        });
    } else {
      dispatch(processFail("Doesn't have permission to perform this action"));
    }
  };
};

export const updateAdvancedTaskFilteredData = (
  appData,
  filterQuery,
  filterType
) => {
  return (dispatch) => {
    dispatch(
      updateAdvancedFilterTask(appData.process_key, filterQuery, filterType)
    );
  };
};

export const getProcessOngoing = (
  offset,
  process_key,
  pageSize,
  filter,
  processStateFilter = null
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    dispatch(processStart());
    getAuthToken();
    let size = pageSize || SIZE;
    let page = (offset - 1) * size;
    let payload = {
      processDefinitionKey: process_key,
      start: page < 0 ? 0 : page,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      selectedState: processStateFilter,
      ...convertToRawQuery(advFilterQuery),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((ongoing) => {
        dispatch(processDetailsOngoing(ongoing, offset));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};
export const getProcessOpenBucket = (
  offset,
  process_key,
  pageSize,
  filter,
  processStateFilter = null
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    dispatch(processStart());
    getAuthToken();
    let size = pageSize || SIZE;
    let page = (offset - 1) * size;
    let payload = {
      processDefinitionKey: process_key,
      start: page < 0 ? 0 : page,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      selectedState: processStateFilter,
      ...convertToRawQuery(advFilterQuery, "open"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((openBucket) => {
        dispatch(processDetailsOpenBucket(openBucket, offset));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getProcessReworkBucket = (
  offset,
  process_key,
  pageSize,
  filter,
  processStateFilter = null
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    dispatch(processStart());
    getAuthToken();
    let size = pageSize || SIZE;
    let page = (offset - 1) * size;
    let payload = {
      processDefinitionKey: process_key,
      start: page < 0 ? 0 : page,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      selectedState: processStateFilter,
      ...convertToRawQuery(advFilterQuery, "rework"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((reworkBucket) => {
        dispatch(processDetailsReworkBucket(reworkBucket, offset));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getProcessAssignedBucket = (
  offset,
  process_key,
  pageSize,
  filter,
  processStateFilter = null
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    dispatch(processStart());
    getAuthToken();
    let size = pageSize || SIZE;
    let page = (offset - 1) * size;
    let payload = {
      processDefinitionKey: process_key,
      start: page < 0 ? 0 : page,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      selectedState: processStateFilter,
      ...convertToRawQuery(advFilterQuery, "assigned"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((assignedBucket) => {
        dispatch(processDetailsAssignedBucket(assignedBucket, offset));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getProcessSubmittedBucket = (
  offset,
  process_key,
  pageSize,
  filter,
  processStateFilter = null
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    dispatch(processStart());
    getAuthToken();
    let size = pageSize || SIZE;
    let page = (offset - 1) * size;
    let payload = {
      processDefinitionKey: process_key,
      start: page < 0 ? 0 : page,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      selectedState: processStateFilter,
      ...convertToRawQuery(advFilterQuery, "submitted"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((submittedBucket) => {
        dispatch(processDetailsSubmittedBucket(submittedBucket, offset));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getProcessQcAllocatedBucket = (
  offset,
  process_key,
  pageSize,
  filter,
  processStateFilter = null
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    dispatch(processStart());
    getAuthToken();
    let size = pageSize || SIZE;
    let page = (offset - 1) * size;
    let payload = {
      processDefinitionKey: process_key,
      start: page < 0 ? 0 : page,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      selectedState: processStateFilter,
      ...convertToRawQuery(advFilterQuery, "qcAllocated"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((qcAllocatedBucket) => {
        dispatch(processDetailsQcAllocatedBucket(qcAllocatedBucket, offset));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getProcessQcDoneBucket = (
  offset,
  process_key,
  pageSize,
  filter,
  processStateFilter = null
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    dispatch(processStart());
    getAuthToken();
    let size = pageSize || SIZE;
    let page = (offset - 1) * size;
    let payload = {
      processDefinitionKey: process_key,
      start: page < 0 ? 0 : page,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      selectedState: processStateFilter,
      ...convertToRawQuery(advFilterQuery, "qcDone"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((qcDoneBucket) => {
        dispatch(processDetailsQcDoneBucket(qcDoneBucket, offset));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getProcessQcRejectedBucket = (
  offset,
  process_key,
  pageSize,
  filter,
  processStateFilter = null
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    dispatch(processStart());
    getAuthToken();
    let size = pageSize || SIZE;
    let page = (offset - 1) * size;
    let payload = {
      processDefinitionKey: process_key,
      start: page < 0 ? 0 : page,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: true,
      deleted: false,
      includeProcessVariables: true,
      selectedState: processStateFilter,
      ...convertToRawQuery(advFilterQuery, "qcRejected"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((qcDoneBucket) => {
        dispatch(processDetailsQcRejectedBucket(qcDoneBucket, offset));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getProcessOngoingAll = (process_key, size, cards, filter) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    // dispatch(processStart())
    getAuthToken();
    let payload = {
      processDefinitionKey: process_key,
      start: 0,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      ...convertToRawQuery(advFilterQuery),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((ongoing) => {
        let result = emailPhone(ongoing.data.data.data);
        dispatch(selectedCardsList(result));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getAllProcessOpenBucket = (process_key, size, cards, filter) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    // dispatch(processStart())
    getAuthToken();
    let payload = {
      processDefinitionKey: process_key,
      start: 0,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      ...convertToRawQuery(advFilterQuery, "open"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((openBucket) => {
        let result = emailPhone(openBucket.data.data.data);
        dispatch(selectedCardsList(result));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getAllProcessReworkBucket = (process_key, size, cards, filter) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    // dispatch(processStart())
    getAuthToken();
    let payload = {
      processDefinitionKey: process_key,
      start: 0,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      ...convertToRawQuery(advFilterQuery, "rework"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((reworkBucket) => {
        let result = emailPhone(reworkBucket.data.data.data);
        dispatch(selectedCardsList(result));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getAllProcessAssignedBucket = (
  process_key,
  size,
  cards,
  filter
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    // dispatch(processStart())
    getAuthToken();
    let payload = {
      processDefinitionKey: process_key,
      start: 0,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      ...convertToRawQuery(advFilterQuery, "assigned"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((assignedBucket) => {
        let result = emailPhone(assignedBucket.data.data.data);
        dispatch(selectedCardsList(result));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getAllProcessSubmittedBucket = (
  process_key,
  size,
  cards,
  filter
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    // dispatch(processStart())
    getAuthToken();
    let payload = {
      processDefinitionKey: process_key,
      start: 0,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      ...convertToRawQuery(advFilterQuery, "submitted"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((submittedBucket) => {
        let result = emailPhone(submittedBucket.data.data.data);
        dispatch(selectedCardsList(result));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getAllProcessQcAllocatedBucket = (
  process_key,
  size,
  cards,
  filter
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    // dispatch(processStart())
    getAuthToken();
    let payload = {
      processDefinitionKey: process_key,
      start: 0,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      ...convertToRawQuery(advFilterQuery, "qcAllocated"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((qcAllocatedBucket) => {
        let result = emailPhone(qcAllocatedBucket.data.data.data);
        dispatch(selectedCardsList(result));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getAllProcessQcDoneBucket = (process_key, size, cards, filter) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    // dispatch(processStart())
    getAuthToken();
    let payload = {
      processDefinitionKey: process_key,
      start: 0,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: false,
      deleted: false,
      includeProcessVariables: true,
      ...convertToRawQuery(advFilterQuery, "qcDone"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((qcDoneBucket) => {
        let result = emailPhone(qcDoneBucket.data.data.data);
        dispatch(selectedCardsList(result));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getAllProcessQcRejectedBucket = (
  process_key,
  size,
  cards,
  filter
) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    // dispatch(processStart())
    getAuthToken();
    let payload = {
      processDefinitionKey: process_key,
      start: 0,
      size: size,
      sort: "startTime",
      order: "desc",
      finished: true,
      deleted: false,
      includeProcessVariables: true,
      ...convertToRawQuery(advFilterQuery, "qcRejected"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((qcRejectedBucket) => {
        let result = emailPhone(qcRejectedBucket.data.data.data);
        dispatch(selectedCardsList(result));
      })
      .catch((err) => {
        dispatch(processFail(err.response));
      });
  };
};

export const getProcessCompleted = (offset, process_key, pageSize, filter) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    dispatch(processStart());
    getAuthToken();
    let size = pageSize || SIZE;
    let page = (offset - 1) * size;
    let payload = {
      processDefinitionKey: process_key,
      start: page < 0 ? 0 : page,
      size: size,
      sort: "endTime",
      order: "desc",
      finished: true,
      deleted: false,
      includeProcessVariables: true,
      ...convertToRawQuery(advFilterQuery, "completed"),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((completed) => {
        dispatch(processDetailsCompleted(completed, offset));
      })
      .catch((err) => {
        dispatch(processFail(err.response.data));
      });
  };
};

export const getProcessWithdrawn = (offset, process_key, pageSize, filter) => {
  return (dispatch, getState) => {
    let advFilterQuery = getState().process.allAppsAdvFilterQuery[process_key];
    dispatch(processStart());
    getAuthToken();
    let size = pageSize || SIZE;
    let page = (offset - 1) * size;
    let payload = {
      processDefinitionKey: process_key,
      start: page < 0 ? 0 : page,
      size: size,
      sort: "endTime",
      order: "desc",
      finished: true,
      deleted: true,
      includeProcessVariables: true,
      ...convertToRawQuery(advFilterQuery),
      query_data: { ...advFilterQuery },
    };
    let activeFilter = "";
    if (filter) {
      activeFilter = `?filter=${filter}`;
    }
    axios
      .post(`/api/apps/process-instances${activeFilter}`, payload)
      .then((withdrawn) => {
        dispatch(processDetailsWithdrawn(withdrawn, offset));
      })
      .catch((err) => {
        dispatch(processFail(err.response.data));
      });
  };
};

export const onHandleStore = (event, id, email, phone, switchAll) => {
  return (dispatch) => {
    dispatch(selectedprocessCard(event, id, email, phone, switchAll));
  };
};

export const clearAll = () => {
  return (dispatch) => {
    dispatch(clearAllSelected());
  };
};

export const selectedProcess = (processType) => {
  return (dispatch) => {
    dispatch(selectedProcessType(processType));
  };
};

export const setDateValueAdv = (dateValueObj) => {
  return (dispatch) => {
    dispatch(setDateValueAdvFilter(dateValueObj));
  };
};

export const getTaskUsers = () => {
  return async (dispatch) => {
    getAuthToken();
    try {
      const res = await axios.get(`/api/users/org_users/task_users`);
      dispatch(taskUsers(res.data.data));
    } catch (e) {
      dispatch(addToast("error", "Error", "Failed to get task users!"));
    }
  };
};

export const searchProcess = (
  isNewSearchData,
  processId,
  processType,
  searchData,
  pageNo = null,
  pageSize,
  filter
) => {
  return (dispatch) => {
    dispatch(processStart());
    let page = Number(pageNo);
    let start = page ? (page - 1) * pageSize : 0;
    let size = pageSize || SIZE;

    getAuthToken();
    let searchFilter = "";
    if (filter) {
      searchFilter = `&filter=${filter}`;
    }

    if (processType === "Ongoing process") {
      axios
        .post(
          `/api/apps/${processId}/search?process_type=${processType}&start=${start}&size=${size}&order=desc&sort=endTime${searchFilter}`,
          searchData
        )
        .then((res) => {
          dispatch(processSearchResult(res, processType, searchData, page));
        })
        .catch((err) => {
          dispatch(processFail(err.response));
        });
      if (isNewSearchData) {
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Completed process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res1) => {
            let process_type = "Completed process";
            let count = res1.data.data.completed.total;
            let data = res1.data.data.completed.data;
            dispatch(processSearchResultCount(process_type, count, data));
          });
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Withdrawn process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res2) => {
            let process_type = "Withdrawn process";
            let count = res2.data.data.withdrawn.total;
            let data = res2.data.data.withdrawn.data;
            dispatch(processSearchResultCount(process_type, count, data));
          })
          .catch((err) => {
            dispatch(processFail(err.response));
          });
      }
    } else if (processType === "open process") {
      axios
        .post(
          `/api/apps/${processId}/search?process_type=${processType}&start=${start}&size=${size}&order=desc&sort=endTime${searchFilter}`,
          searchData
        )
        .then((res) => {
          dispatch(processSearchResult(res, processType, searchData, page));
        })
        .catch((err) => {
          dispatch(processFail(err.response));
        });
      if (isNewSearchData) {
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Completed process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res1) => {
            let process_type = "open process";
            let count = res1.data.data.completed.total;
            let data = res1.data.data.completed.data;
            dispatch(processSearchResultCount(process_type, count, data));
          });
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Withdrawn process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res2) => {
            let process_type = "open process";
            let count = res2.data.data.withdrawn.total;
            let data = res2.data.data.withdrawn.data;
            dispatch(processSearchResultCount(process_type, count, data));
          })
          .catch((err) => {
            dispatch(processFail(err.response));
          });
      }
    } else if (processType === "rework process") {
      axios
        .post(
          `/api/apps/${processId}/search?process_type=${processType}&start=${start}&size=${size}&order=desc&sort=endTime${searchFilter}`,
          searchData
        )
        .then((res) => {
          dispatch(processSearchResult(res, processType, searchData, page));
        })
        .catch((err) => {
          dispatch(processFail(err.response));
        });
      if (isNewSearchData) {
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Completed process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res1) => {
            let process_type = "rework process";
            let count = res1.data.data.completed.total;
            let data = res1.data.data.completed.data;
            dispatch(processSearchResultCount(process_type, count, data));
          });
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Withdrawn process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res2) => {
            let process_type = "rework process";
            let count = res2.data.data.withdrawn.total;
            let data = res2.data.data.withdrawn.data;
            dispatch(processSearchResultCount(process_type, count, data));
          })
          .catch((err) => {
            dispatch(processFail(err.response));
          });
      }
    } else if (processType === "assigned process") {
      axios
        .post(
          `/api/apps/${processId}/search?process_type=${processType}&start=${start}&size=${size}&order=desc&sort=endTime${searchFilter}`,
          searchData
        )
        .then((res) => {
          dispatch(processSearchResult(res, processType, searchData, page));
        })
        .catch((err) => {
          dispatch(processFail(err.response));
        });
      if (isNewSearchData) {
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Completed process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res1) => {
            let process_type = "assigned process";
            let count = res1.data.data.completed.total;
            let data = res1.data.data.completed.data;
            dispatch(processSearchResultCount(process_type, count, data));
          });
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Withdrawn process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res2) => {
            let process_type = "assigned process";
            let count = res2.data.data.withdrawn.total;
            let data = res2.data.data.withdrawn.data;
            dispatch(processSearchResultCount(process_type, count, data));
          })
          .catch((err) => {
            dispatch(processFail(err.response));
          });
      }
    } else if (processType === "submitted process") {
      axios
        .post(
          `/api/apps/${processId}/search?process_type=${processType}&start=${start}&size=${size}&order=desc&sort=endTime${searchFilter}`,
          searchData
        )
        .then((res) => {
          dispatch(processSearchResult(res, processType, searchData, page));
        })
        .catch((err) => {
          dispatch(processFail(err.response));
        });
      if (isNewSearchData) {
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Completed process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res1) => {
            let process_type = "submitted process";
            let count = res1.data.data.completed.total;
            let data = res1.data.data.completed.data;
            dispatch(processSearchResultCount(process_type, count, data));
          });
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Withdrawn process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res2) => {
            let process_type = "submitted process";
            let count = res2.data.data.withdrawn.total;
            let data = res2.data.data.withdrawn.data;
            dispatch(processSearchResultCount(process_type, count, data));
          })
          .catch((err) => {
            dispatch(processFail(err.response));
          });
      }
    } else if (processType === "qc allocated process") {
      axios
        .post(
          `/api/apps/${processId}/search?process_type=${processType}&start=${start}&size=${size}&order=desc&sort=endTime${searchFilter}`,
          searchData
        )
        .then((res) => {
          dispatch(processSearchResult(res, processType, searchData, page));
        })
        .catch((err) => {
          dispatch(processFail(err.response));
        });
      if (isNewSearchData) {
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Completed process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res1) => {
            let process_type = "qc allocated process";
            let count = res1.data.data.completed.total;
            let data = res1.data.data.completed.data;
            dispatch(processSearchResultCount(process_type, count, data));
          });
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Withdrawn process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res2) => {
            let process_type = "qc allocated process";
            let count = res2.data.data.withdrawn.total;
            let data = res2.data.data.withdrawn.data;
            dispatch(processSearchResultCount(process_type, count, data));
          })
          .catch((err) => {
            dispatch(processFail(err.response));
          });
      }
    } else if (processType === "qc done process") {
      axios
        .post(
          `/api/apps/${processId}/search?process_type=${processType}&start=${start}&size=${size}&order=desc&sort=endTime${searchFilter}`,
          searchData
        )
        .then((res) => {
          dispatch(processSearchResult(res, processType, searchData, page));
        })
        .catch((err) => {
          dispatch(processFail(err.response));
        });
      if (isNewSearchData) {
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Completed process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res1) => {
            let process_type = "qc done process";
            let count = res1.data.data.completed.total;
            let data = res1.data.data.completed.data;
            dispatch(processSearchResultCount(process_type, count, data));
          });
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Withdrawn process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res2) => {
            let process_type = "qc done process";
            let count = res2.data.data.withdrawn.total;
            let data = res2.data.data.withdrawn.data;
            dispatch(processSearchResultCount(process_type, count, data));
          })
          .catch((err) => {
            dispatch(processFail(err.response));
          });
      }
    } else if (processType === "qc rejected process") {
      axios
        .post(
          `/api/apps/${processId}/search?process_type=${processType}&start=${start}&size=${size}&order=desc&sort=endTime${searchFilter}`,
          searchData
        )
        .then((res) => {
          dispatch(processSearchResult(res, processType, searchData, page));
        })
        .catch((err) => {
          dispatch(processFail(err.response));
        });
      if (isNewSearchData) {
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Completed process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res1) => {
            let process_type = "qc rejected process";
            let count = res1.data.data.completed.total;
            let data = res1.data.data.completed.data;
            dispatch(processSearchResultCount(process_type, count, data));
          });
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Withdrawn process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res2) => {
            let process_type = "qc rejected process";
            let count = res2.data.data.withdrawn.total;
            let data = res2.data.data.withdrawn.data;
            dispatch(processSearchResultCount(process_type, count, data));
          })
          .catch((err) => {
            dispatch(processFail(err.response));
          });
      }
    } else if (processType === "Completed process") {
      axios
        .post(
          `/api/apps/${processId}/search?process_type=${processType}&start=${start}&size=${size}&order=desc&sort=endTime${searchFilter}`,
          searchData
        )
        .then((res) => {
          dispatch(processSearchResult(res, processType, searchData, page));
        });
      if (isNewSearchData) {
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Ongoing process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res1) => {
            let process_type = "Ongoing process";
            let count = res1.data.data.ongoing.total;
            let data = res1.data.data.ongoing.data;
            dispatch(processSearchResultCount(process_type, count, data));
          });
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Withdrawn process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res2) => {
            let process_type = "Withdrawn process";
            let count = res2.data.data.withdrawn.total;
            let data = res2.data.data.withdrawn.data;
            dispatch(processSearchResultCount(process_type, count, data));
          })
          .catch((err) => {
            dispatch(processFail(err.response));
          });
      }
    } else if (processType === "Withdrawn process") {
      axios
        .post(
          `/api/apps/${processId}/search?process_type=${processType}&start=${start}&size=${size}&order=desc&sort=endTime${searchFilter}`,
          searchData
        )
        .then((res) => {
          dispatch(processSearchResult(res, processType, searchData, page));
        });
      if (isNewSearchData) {
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Ongoing process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res1) => {
            let process_type = "Ongoing process";
            let count = res1.data.data.ongoing.total;
            let data = res1.data.data.ongoing.data;
            dispatch(processSearchResultCount(process_type, count, data));
          });
        axios
          .post(
            `/api/apps/${processId}/search?process_type=Completed process&start=${start}&size=${0}&order=desc&sort=endTime${searchFilter}`,
            searchData
          )
          .then((res2) => {
            let process_type = "Completed process";
            let count = res2.data.data.completed.total;
            let data = res2.data.data.completed.data;
            dispatch(processSearchResultCount(process_type, count, data));
          })
          .catch((err) => {
            dispatch(processFail(err.response));
          });
      }
    }
  };
};

export const clearSearch = () => {
  return (dispatch) => {
    dispatch(clearProcessSearchResult());
  };
};

export const setProcessFilter = (filteredOptions, selectedOption) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FILTER_FROM_DASHBOARD,
      filteredOptions,
      selectedOption,
    });
  };
};

export const toggleProcessSearchBar = (show) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.TOGGLE_PROCESS_SEARCH_BAR,
      show,
    });
  };
};

export const updateSearchData = (searchData) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_SEARCH_DATA,
      searchData,
    });
  };
};

export const clearAllProcess = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CLEAR_ALL_PROCESS,
    });
  };
};
